import { render } from "./filesList.vue?vue&type=template&id=4c45bf97"
import script from "./filesList.vue?vue&type=script&lang=js"
export * from "./filesList.vue?vue&type=script&lang=js"

import "./filesList.vue?vue&type=style&index=0&id=4c45bf97&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__